import Vue from 'vue';
import i18n from '@/lang';
// import { CSS2DObject } from 'three/examples/jsm/renderers/CSS2DRenderer';
// import { CSS2DObject } from 'three/examples/jsm/renderers/CSS2DRenderer';
import { CSS2DObject } from '../renderer/CSS3DRenderer';
import router from '@/router';
class Dom3d extends CSS2DObject {
    // private dom:any;
    props;
    center;
    innerDom;
    outDom;
    instance;
    constructor(data) {
        const { renderProps, onLoad, position, zIndex = 0, visible = true } = data;
        const { dom, instance, data: InstanceData, emitMethods, isFront } = renderProps;
        let InnerDom;
        let OutDom;
        if (instance) {
            const outDom = document.createElement('div');
            outDom.style.pointerEvents = 'none';
            const innerDom = document.createElement('div');
            outDom.appendChild(innerDom);
            const Tool = Vue.extend(instance);
            const tool = new Tool({ data: () => InstanceData, router }); // 动态组件this上挂载的router为undefined，手动传入
            if (tool.$i18n) {
                tool.$i18n.locale = i18n.locale;
            }
            tool.$mount(innerDom);
            if (tool.$el) {
                tool.$el.style.pointerEvents = 'auto';
            }
            else {
                console.info('组件实例必须存在，切勿用v-if等销毁组件的方式控制顶层数据显示隐藏');
            }
            if (InstanceData) {
                for (const i in InstanceData) {
                    tool.$set(tool, i, InstanceData[i]);
                }
            }
            if (emitMethods) {
                for (const i in emitMethods) {
                    tool.$on(i, emitMethods[i]);
                }
            }
            OutDom = outDom;
            InnerDom = tool;
        }
        else {
            if (dom) {
                throw new Error('3D地图已删除旧版dom接入方式，请使用vueConfig形式接入');
            }
        }
        if (OutDom && OutDom.style) {
            OutDom.style.zIndex = '' + zIndex;
        }
        if (!OutDom)
            OutDom = document.createElement('div');
        OutDom.isFront = isFront;
        super(OutDom);
        this.outDom = OutDom;
        this.innerDom = InnerDom;
        this.instance = instance;
        this.props = data;
        this.visible = visible;
        this.position.set(position.x, position.y, position.z);
        this.name = this.uuid;
        this.center = this.position;
        // this.update(data);
        if (onLoad && typeof onLoad === 'function') {
            onLoad(this);
        }
    }
    update(data) {
        const { renderProps, position, zIndex = 0, visible = true } = data;
        this.visible = visible;
        this.position.set(position.x, position.y, position.z);
        const { instance, data: InstanceData, emitMethods } = renderProps;
        if (instance !== this.instance) {
            this.innerDom?.$el.remove();
            const innerDom = document.createElement('div');
            this.outDom.appendChild(innerDom);
            const Tool = Vue.extend(instance);
            const tool = new Tool({ data: () => InstanceData });
            if (tool.$i18n) {
                tool.$i18n.locale = i18n.locale;
            }
            tool.$mount(innerDom);
            if (tool.$el) {
                tool.$el.style.pointerEvents = 'auto';
            }
            else {
                console.info('组件实例必须存在，切勿用v-if等销毁组件的方式控制顶层数据显示隐藏');
            }
            this.innerDom = tool;
        }
        if (this.innerDom) {
            if (InstanceData) {
                for (const i in InstanceData) {
                    this.innerDom.$set(this.innerDom, i, InstanceData[i]);
                }
            }
            if (this.props.renderProps.emitMethods) {
                const emitMethods = this.props.renderProps.emitMethods;
                for (const i in emitMethods) {
                    this.innerDom.$off(i, emitMethods[i]);
                }
            }
            if (emitMethods) {
                for (const i in emitMethods) {
                    this.innerDom.$on(i, emitMethods[i]);
                }
            }
        }
        this.props = data;
    }
    onMouseEnter() {
        // console.log(213123123);
    }
    dispose() {
        this.parent?.remove(this);
        this.clear();
        this.innerDom?.$destroy();
        this.innerDom?.$el.parentElement?.removeChild(this.innerDom.$el);
        this.outDom?.remove();
    }
}
export default Dom3d;
